import '@widesk-ui/styles/TextArea.scss';
import AntdInput              from 'antd/lib/input';
import { ChangeEventHandler } from 'react';

export type TextAreaProps = Omit<FieldProps, 'onChange'> & {
	value?: string;
	onChange?: ChangeEventHandler<HTMLTextAreaElement>;
	autoFocus?: boolean;
	placeholder?: string;
	rows?: number;
	maxLength?: number;
	showCount?: boolean;
	/** Hauteur suivant le contenu. `{ minRows, maxRows }` pour la borner. Prime sur `rows`. */
	autoSize?: boolean | { minRows?: number; maxRows?: number };
}

export default function TextArea(props: TextAreaProps) {
	return (
		<AntdInput.TextArea
			placeholder={props.placeholder}
			autoFocus={props.autoFocus}
			disabled={props.disabled}
			onChange={props.onChange}
			size={props.size}
			value={props.value}
			style={props.style}
			rows={props.rows}
			autoSize={props.autoSize}
			id={props.id ? `textarea-${props.id}` : undefined}
			maxLength={props.maxLength}
			showCount={props.showCount}
		/>
	);
}
